import * as e from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Sparkle.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(t, { ref: a, ...r, weights: m }));
o.displayName = "SparkleIcon";
const s = o;
export {
  s as Sparkle,
  o as SparkleIcon
};
